/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for ``POST /api/jobs/{job_id}/sequences/{id}/clone-steps``.
 *
 * Copies the steps of ``source_sequence_id`` into the path sequence,
 * overwriting any existing steps. The source must belong to the same org
 * and cannot be the target sequence itself.
 */
export interface SequenceCloneStepsRequest {
  source_sequence_id: string;
}
